// @ts-strict-ignore
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { uniqueId } from 'lodash-es';
import { InputBaseComponent } from '../input-base/input-base.component';

export interface InputTextCancelEvent {
  /**
   * The value of the control before edit started.
   */
  originalValue: string | number;
  /**
   * The value of the control when cancel was triggered. Might be identical to `originalValue`.
   */
  canceledValue: string | number;
}

/**
 * @deprecated Use app-input-text
 */
@Component({
    selector: 'ui-input-text',
    templateUrl: './input-text.component.html',
    styleUrls: ['./input-text.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputTextComponent extends InputBaseComponent<string | number> {
  /**
   * If set to true, Esc will reset the control to the value before editing.
   * And an `InputTextCancelEvent` will be sent on `onCancel` nothing more will happen.
   * It is up to the consumer to handle anything else, such as changing focus.
   */
  @Input() allowCancel: boolean = false;
  @Input() dataCy?: string;
  @Input() max?: string;
  @Input() min?: string;
  @Input() name: string = uniqueId('text');
  @Input() placeholder: string = '';
  @Input() step: string = null;
  @Input() tabindex?: number;
  @Input() type: string = 'text';

  @Output() onCancel: EventEmitter<InputTextCancelEvent> = new EventEmitter();
  @Output() onEmit: EventEmitter<string | number> = new EventEmitter();
  @Output() blur: EventEmitter<string | number> = new EventEmitter();
  @Output() onFocus: EventEmitter<string | number> = new EventEmitter();

  onBlur() {
    if (this.control.value !== this.value) {
      this._emit();
    } else {
      this.onTouched(this.value);
    }
    this.blur.emit();
  }

  onEsc() {
    if (this.allowCancel) {
      const result: InputTextCancelEvent = {
        originalValue: this.control.value,
        canceledValue: this.value,
      };
      this.control.control.setValue(result.originalValue);
      this.control.control.updateValueAndValidity();
      this.onCancel.emit(result);
    }
  }

  onFocusInput() {
    this.onFocus.emit();
  }

  onInputKeyDown($event: KeyboardEvent) {
    if ($event.key === 'Enter') {
      this._emit();
    }
  }

  private _emit() {
    if (this.type === 'number') {
      this.onTouched(+this.value);
      this.onChange(+this.value);
    } else {
      this.onTouched(this.value);
      this.onChange(this.value);
    }
    this.onEmit.emit(this.value);
  }
}
